module.exports = __webpack_public_path__ + "static/img/course-shu.0a3d8975.png";